module.exports = __webpack_public_path__ + "img/1.36d7ac5d.jpg";